import React, { Component } from 'react'
import { Section, Input, Checkbox } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'
export default class HideLeadingBidTime extends Component {
  render() {
    const {
      auctionType,
      formData,
      isErrHideLeadingBidTime,
      isSetState,
    } = this.props
    return (
      <Section className="form-group">
        <label className="hide-leading-bid-time-before">
          Hide Leading Bid <br />
          Time before <br />
          close (minutes)
          {auctionType === 'Sealed' && (
            <>
              (Optional)
              <br />
              &nbsp;
            </>
          )}
        </label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <Checkbox
              id="no_HideLeadingBidTime"
              value="no_HideLeadingBidTime"
              type="radio"
              name="no_HideLeadingBidTime"
              checked={!formData.step2.eventInformation.is_HideLeadingBidTime}
              className="inline"
              onChange={e => {
                formData.step2.eventInformation.is_HideLeadingBidTime = false
                formData.step2.eventInformation.eventHideLeadingBidTime = ''
                isSetState({
                  formData,
                  isErrHideLeadingBidTime: false,
                })
              }}
            >
              <div
                className="hide-leading-bid-time-before"
                style={{ width: '105px' }}
              >
                No
              </div>
            </Checkbox>

            <Section style={{ justifyContent: 'space-between' }}>
              <Checkbox
                id="yes_HideLeadingBidTime"
                value="yes_HideLeadingBidTime"
                type="radio"
                name="yes_HideLeadingBidTime"
                checked={formData.step2.eventInformation.is_HideLeadingBidTime}
                className="inline"
                onChange={e => {
                  formData.step2.eventInformation.is_HideLeadingBidTime = true
                  isSetState({
                    formData,
                  })
                }}
              >
                <div className="hide-leading-bid-time-before">Yes</div>
              </Checkbox>

              {/* input Hide Leading Bid Time  */}
              <Section
                className={`form-group ${
                  isErrHideLeadingBidTime && 'is-error'
                }`}
                style={{ width: '60%' }}
              >
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <NumberFormat
                      placeholder="Minutes"
                      value={
                        formData.step2.eventInformation.eventHideLeadingBidTime
                      }
                      isAllowed={inputObj => {
                        const { value } = inputObj
                        if (value !== '-') return true
                        return false
                      }}
                      maxLength={11}
                      customInput={Input}
                      decimalScale={0}
                      onValueChange={e => {
                        if (e.floatValue <= 0) {
                          formData.step2.eventInformation.eventHideLeadingBidTime = null
                        } else {
                          formData.step2.eventInformation.eventHideLeadingBidTime =
                            e.floatValue
                        }
                        isSetState({
                          formData,
                          isErrHideLeadingBidTime: false,
                        })
                      }}
                      thousandSeparator={true}
                      readOnly={
                        !formData.step2.eventInformation.is_HideLeadingBidTime
                      }
                    />
                  </Section>
                  {isErrHideLeadingBidTime && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="message">{STRING.INVALID}</Section>
        </Section>
      </Section>
    )
  }
}
